import Vue from 'vue'

import {
  Button,
  Tab, Tabs,
  Divider,
  Field,
  Cell, CellGroup,
  Popup,
  Picker,
  DatetimePicker,
  Toast,
  Loading,
  Overlay,
  Dialog,
  Icon,
  Uploader,
  ImagePreview,
  Image as VanImage,
  Checkbox, CheckboxGroup,
  Tabbar, TabbarItem,
  List,
  Col, Row,
  Card,

} from 'vant'

Vue.use(Button)

  .use(Tab)
  .use(Tabs)
  .use(Divider)
  .use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Toast)
  .use(Loading)
  .use(Overlay)
  .use(Dialog)
  .use(Icon)
  .use(Uploader)
  .use(ImagePreview)
  .use(VanImage)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Tabbar)
  .use(TabbarItem)
  .use(List)
  .use(Col)
  .use(Row)
  .use(Card)
